import { ViewModel } from 'view_models/view_model'
import { Institution } from 'entities/institution'
import { AddressViewModel } from './address_view_model'
import { Flex } from 'components/shared/flex'
import { Badge, Button, ProgressBar } from 'react-bootstrap'

export class InstitutionViewModel extends ViewModel<Institution> {
    public contractDateText = (): string => {
        return this.toDateText(this.object.contractDate)
    }
    public addressVm = (): AddressViewModel => {
        return new AddressViewModel(this.object.address!)
    }

    public productItemsView = () => {
        return (
            <Flex>
                <div>
                    {this.object.productItems
                        ?.sort((a, b) => Number(a.id) - Number(b.id))
                        .map((pi) => (
                            <Badge key={pi.id!} bg="none" style={{ backgroundColor: pi.color, margin: 2 }}>
                                {pi.name}
                            </Badge>
                        ))}
                </div>
            </Flex>
        )
    }

    public remainingRequestFormProgressView = (product: 'scan' | 'lite' | 'check', hovered?: boolean, onClickDetail?: () => void) => {
        let percent = 0
        const remainingRequestForm = this.object[`${product}RemainingRequestFormCount`]
        const sendFormCount = this.object[`${product}SendFormCount`]
        if (remainingRequestForm && sendFormCount) {
            percent = (remainingRequestForm / (sendFormCount * 1.0)) * 100
        }

        let variant = 'success'
        if (percent <= 25) {
            variant = 'danger'
        } else if (percent <= 50) {
            variant = 'warning'
        }

        const label = `${remainingRequestForm}/${sendFormCount}`
        if (hovered) {
            return (
                <>
                    <Flex alignItems="center">
                        <Button variant={`outline-primary`} size="sm" style={{ flexGrow: 1, marginRight: 5, fontSize: 11, padding: 1 }} onClick={onClickDetail}>
                            発行履歴
                        </Button>
                        <span style={{ fontSize: 10, width: 32, textAlign: 'center' }}>{label}</span>
                    </Flex>
                </>
            )
        } else {
            return (
                <Flex>
                    <ProgressBar striped variant={variant} now={percent} max={100} style={{ flexGrow: 1, marginRight: 5 }} />
                    <span style={{ fontSize: 10, width: 32, textAlign: 'center' }}>{label}</span>
                </Flex>
            )
        }
    }
}
